import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import debounce from 'lodash.debounce';
import { useCallback, useMemo, useState } from 'react';
import { useToggleGroup } from '@snack-uikit/toggles';
export function useExpanded(id) {
  var _useToggleGroup = useToggleGroup({
      value: id
    }),
    isExpanded = _useToggleGroup.isChecked,
    handleExpandedChange = _useToggleGroup.handleClick;
  var _useState = useState(isExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpandedDebounced = _useState2[0],
    setIsExpandedDebounced = _useState2[1];
  var debouncedSetIsExpandedDebounced = useMemo(function () {
    return debounce(setIsExpandedDebounced, 300);
  }, []);
  var handleToggleExpanded = useCallback(function (expanded) {
    handleExpandedChange();
    debouncedSetIsExpandedDebounced(expanded);
  }, [debouncedSetIsExpandedDebounced, handleExpandedChange]);
  return {
    isExpanded: isExpanded,
    isExpandedDebounced: isExpandedDebounced,
    handleToggleExpanded: handleToggleExpanded
  };
}